import { Type } from "@shared/ui/Type";
import { Button } from "@shared/ui/Button";
import { Article } from "../../support.types";

export type Props = {
  categoryName: string;
  articles: Article[];
  onArticleClick: (article: Article) => void;
};

export function SupportSearchFormResultItem({
  categoryName,
  articles,
  onArticleClick,
}: Props) {
  return (
    <div className="flex flex-col gap-2">
      <Type variant="h4" className="text-brand-700">
        {categoryName}
      </Type>
      <div>
        {articles.map((article) => (
          <Button
            variant="ghost"
            onClick={() => onArticleClick(article)}
            key={article.id}
            data-testid={`support-search-result-${article.id}`}
          >
            {article.title}
          </Button>
        ))}
      </div>
    </div>
  );
}

export default SupportSearchFormResultItem;
